// ----------------------------------------------------------------------
// <copyright file="Izenda.IconAfterCursor.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var getCaretCoordinates = require('share/utils/Izenda.CaretCoordinatesUtils');
  const { omit } = require('lodash/fp');
  var SPACE_ICON_BELOW_CURSOR = 15;
  var ICON_HEIGHT = 30;
  var TYPE = {
    TEXT_AREA: 'textarea',
    INPUT: 'input'
  };

  var IconAfterCursorInput = React.createClass({
    getDefaultProps: function() {
      return {
        iconClassName: 'icon-lightbulb',
        type: TYPE.TEXT_AREA
      };
    },

    getInitialState: function() {
      return {
        isInitial: true,
        style: {
          top: 0,
          left: 0,
          height: ICON_HEIGHT
        }
      };
    },

    setMinMaxTop: function() {
      var input = this.refs.input;
      var coordinates = getCaretCoordinates(input, input.selectionEnd);
      var topPosition = coordinates.top + SPACE_ICON_BELOW_CURSOR;

      if (topPosition < input.clientLeft + SPACE_ICON_BELOW_CURSOR) {
        topPosition = coordinates.top;
      }

      if (topPosition > input.offsetHeight - ICON_HEIGHT) {
        topPosition = input.offsetHeight - ICON_HEIGHT;
      }

      return topPosition;
    },

    updatePosition: function() {
      var input = this.refs.input;
      var coordinates = getCaretCoordinates(input, input.selectionEnd);
      this.setState({
        style: {
          top: this.setMinMaxTop(),
          left: input.offsetLeft - input.scrollLeft + coordinates.left
        }
      });
    },

    renderInput: function() {
      var props = this.props;
      var inputType = props.type;

      var onClick = props.onClick;
      var onKeyUp = props.onKeyUp;
      var onScroll = props.onScroll;
      props = omit(['iconClassName', 'componentType', 'onClickIcon', 'onClick', 'onKeyUp', 'onScroll'], props);

      function handleClick(e) {
        this.updatePosition();
        onClick && onClick(e);
      }

      function handelKeyUp(e) {
        this.updatePosition();
        onKeyUp && onKeyUp(e);
      }

      function handleScroll(e) {
        this.updatePosition();
        onScroll && onScroll(e);
      }

      var inputProps = {
        className: 'form-control',
        onClick: handleClick.bind(this),
        onKeyUp: handelKeyUp.bind(this),
        onScroll: handleScroll.bind(this),
        ref: 'input'
      };

      function createInput() {
        switch (inputType) {
          case TYPE.TEXT_AREA:
            return <textarea {...inputProps} {...props} />;
          case TYPE.INPUT:
            return <input {...inputProps} {...props} />;
          default:
            return <textarea {...inputProps} {...props} />;
        }
      }

      return createInput();
    },

    render: function() {
      var props = this.props;

      function handleIconClick(e) {
        e.preventDefault();
        e.stopPropagation();
        props.onClickIcon && props.onClickIcon(this.state.style);
      }

      function renderIcon() {
        if (!this.state.isInitial && !props.disabled) {
          return (
            <a onMouseDown={handleIconClick.bind(this)} style={this.state.style}>
              <span className={props.iconClassName} />
            </a>
          );
        }
        return null;
      }

      function handleClick(e) {
        this.setState({ isInitial: false });
      }

      return (
        <div onClick={handleClick.bind(this)} className='icon-after-cursor'>
          {this.renderInput()}
          {renderIcon.call(this)}
        </div>
      );
    }
  });

  module.exports = IconAfterCursorInput;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.IconAfterCursorInput.jsx